import React from 'react';

function Svg({ size = 18, children, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IconDashboard = (p) => (
  <Svg {...p}>
    <rect x="3" y="3" width="7" height="9" rx="1.5" />
    <rect x="14" y="3" width="7" height="5" rx="1.5" />
    <rect x="14" y="12" width="7" height="9" rx="1.5" />
    <rect x="3" y="16" width="7" height="5" rx="1.5" />
  </Svg>
);

export const IconUsers = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" />
    <path d="M16 5.2a3.2 3.2 0 0 1 0 5.9" />
    <path d="M18 14.8c2 .8 3.4 2.6 3.4 5.2" />
  </Svg>
);

export const IconKey = (p) => (
  <Svg {...p}>
    <circle cx="8" cy="15" r="4" />
    <path d="M10.9 12.1 20 3" />
    <path d="M17 6l2.5 2.5" />
    <path d="M14.5 8.5 17 11" />
  </Svg>
);

export const IconPen = (p) => (
  <Svg {...p}>
    <path d="M12 20h8" />
    <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7.5 18.5 3 20l1.5-4.5Z" />
  </Svg>
);

export const IconList = (p) => (
  <Svg {...p}>
    <path d="M9 6h11" />
    <path d="M9 12h11" />
    <path d="M9 18h11" />
    <circle cx="4.5" cy="6" r="1.2" fill="currentColor" stroke="none" />
    <circle cx="4.5" cy="12" r="1.2" fill="currentColor" stroke="none" />
    <circle cx="4.5" cy="18" r="1.2" fill="currentColor" stroke="none" />
  </Svg>
);

export const IconChart = (p) => (
  <Svg {...p}>
    <path d="M4 20V10" />
    <path d="M10 20V4" />
    <path d="M16 20v-7" />
    <path d="M21 20H3" />
  </Svg>
);

export const IconUserCog = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3 20c0-3.3 2.7-5.5 6-5.5 1 0 1.9.2 2.7.6" />
    <circle cx="17.5" cy="16.5" r="2.5" />
    <path d="M17.5 12.6v1.2M17.5 19.2v1.2M21.4 14.7l-1 .6M14.6 18.3l-1 .6M21.4 18.3l-1-.6M14.6 14.7l-1-.6" />
  </Svg>
);

export const IconPlus = (p) => (
  <Svg {...p}>
    <path d="M12 5v14M5 12h14" />
  </Svg>
);

export const IconRefresh = (p) => (
  <Svg {...p}>
    <path d="M20 11a8 8 0 1 0-1.6 5.6" />
    <path d="M20 5v6h-6" />
  </Svg>
);

export const IconRocket = (p) => (
  <Svg {...p}>
    <path d="M12 3c3.5 1.6 5.5 4.8 5.5 8.6L14 15h-4l-3.5-3.4C6.5 7.8 8.5 4.6 12 3Z" />
    <circle cx="12" cy="10" r="1.8" />
    <path d="M9.5 15.5 8 21l3-1.4L13 21l-.5-4" />
    <path d="M14.5 15.5 16 21l-1.6-.6" />
  </Svg>
);

export const IconCalendar = (p) => (
  <Svg {...p}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </Svg>
);

export const IconExternal = (p) => (
  <Svg {...p}>
    <path d="M14 4h6v6" />
    <path d="M20 4 11 13" />
    <path d="M18 14v4.5A1.5 1.5 0 0 1 16.5 20h-11A1.5 1.5 0 0 1 4 18.5v-11A1.5 1.5 0 0 1 5.5 6H10" />
  </Svg>
);

export const IconCheck = (p) => (
  <Svg {...p}>
    <path d="M4.5 12.5 9.5 17.5 19.5 6.5" />
  </Svg>
);

export const IconTrash = (p) => (
  <Svg {...p}>
    <path d="M4 7h16" />
    <path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
    <path d="M6 7v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7" />
    <path d="M10 11v6M14 11v6" />
  </Svg>
);

export const IconPlug = (p) => (
  <Svg {...p}>
    <path d="M9 3v5M15 3v5" />
    <path d="M6 8h12v3a6 6 0 0 1-6 6 6 6 0 0 1-6-6Z" />
    <path d="M12 17v4" />
  </Svg>
);

export const IconLogout = (p) => (
  <Svg {...p}>
    <path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" />
    <path d="M10 8 6 12l4 4" />
    <path d="M6 12h9" />
  </Svg>
);

export const IconCopy = (p) => (
  <Svg {...p}>
    <rect x="9" y="9" width="11" height="11" rx="2" />
    <path d="M5 15H4a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v1" />
  </Svg>
);

export const IconEye = (p) => (
  <Svg {...p}>
    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
    <circle cx="12" cy="12" r="3" />
  </Svg>
);

export const IconClock = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 1.8" />
  </Svg>
);

export const IconCheckCircle = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M8.2 12.3 11 15l4.8-5.4" />
  </Svg>
);

export const IconAlert = (p) => (
  <Svg {...p}>
    <path d="M12 4.5 21 19.5H3Z" />
    <path d="M12 10v4" />
    <circle cx="12" cy="17" r="0.9" fill="currentColor" stroke="none" />
  </Svg>
);

export const IconError = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M9 9l6 6M15 9l-6 6" />
  </Svg>
);

export const IconInfo = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 11v5" />
    <circle cx="12" cy="8" r="0.9" fill="currentColor" stroke="none" />
  </Svg>
);

export const IconSparkle = (p) => (
  <Svg {...p}>
    <path d="M12 3.5 13.8 9 19.5 10.8 13.8 12.6 12 18.2 10.2 12.6 4.5 10.8 10.2 9Z" />
    <path d="M18.5 3v3M20 4.5h-3" />
  </Svg>
);

export const IconShield = (p) => (
  <Svg {...p}>
    <path d="M12 3 19 6v5.5c0 4.2-2.9 7.6-7 9.5-4.1-1.9-7-5.3-7-9.5V6Z" />
    <path d="M9 12.2l2.2 2.2L15.2 10" />
  </Svg>
);

export const IconHeart = (p) => (
  <Svg {...p}>
    <path d="M12 20s-7-4.4-7-9.2A3.9 3.9 0 0 1 12 8a3.9 3.9 0 0 1 7 2.8C19 15.6 12 20 12 20Z" />
  </Svg>
);

export const IconComment = (p) => (
  <Svg {...p}>
    <path d="M20 12a7.5 7.5 0 0 1-10.6 6.8L4.5 20l1.3-4.4A7.5 7.5 0 1 1 20 12Z" />
  </Svg>
);

export const IconShare = (p) => (
  <Svg {...p}>
    <circle cx="17.5" cy="6" r="2.5" />
    <circle cx="6.5" cy="12" r="2.5" />
    <circle cx="17.5" cy="18" r="2.5" />
    <path d="M8.8 10.8 15.2 7.2M8.8 13.2l6.4 3.6" />
  </Svg>
);

export const IconEyeViews = IconEye;

export const IconSend = (p) => (
  <Svg {...p}>
    <path d="M21 4 3 10.5l7 2.8 2.8 7Z" />
    <path d="M10 13.5 21 4" />
  </Svg>
);

const BRAND_PATHS = {
  youtube: (
    <g>
      <path d="M22 12s0-3.3-.4-4.8a2.6 2.6 0 0 0-1.8-1.8C18.2 5 12 5 12 5s-6.2 0-7.8.4A2.6 2.6 0 0 0 2.4 7.2C2 8.7 2 12 2 12s0 3.3.4 4.8a2.6 2.6 0 0 0 1.8 1.8C5.8 19 12 19 12 19s6.2 0 7.8-.4a2.6 2.6 0 0 0 1.8-1.8C22 15.3 22 12 22 12Z" />
      <path d="M10 8.8v6.4l5.3-3.2Z" fill="#fff" stroke="none" />
    </g>
  ),
  facebook: (
    <g>
      <path d="M14 8.5V6.8c0-.8.4-1.3 1.4-1.3H17V2.6h-2.4c-2.6 0-4 1.5-4 4v1.9H8.4v3h2.2V21h3.4v-9.5h2.4l.4-3Z" />
    </g>
  ),
  instagram: (
    <g>
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" stroke="none" />
    </g>
  ),
  tiktok: (
    <g>
      <path d="M14 3h2.6a5.4 5.4 0 0 0 4.4 4.4v2.6a8 8 0 0 1-4.4-1.5v6.3A5.9 5.9 0 1 1 10.7 9v2.8a3.1 3.1 0 1 0 2.2 3Z" />
    </g>
  ),
  kwai: (
    <g>
      <path d="M14.8 3c.4 2.3 1.9 3.8 4.2 4.1v2.6a7.3 7.3 0 0 1-4.2-1.4v6.2A5.8 5.8 0 1 1 9 8.7v2.8a3.1 3.1 0 1 0 2.2 3Z" />
      <path d="M17.6 3h2.4v5.6h-2.4z" fill="currentColor" stroke="none" />
    </g>
  ),
  dai: (
    <g>
      <path d="M4 5.5h6.2c3.4 0 5.6 2.2 5.6 5.7s-2.2 5.8-5.6 5.8H4Z" />
      <path d="M16.5 9.5 21 12l-4.5 2.5Z" fill="currentColor" stroke="none" />
    </g>
  ),
};

export function PlatformGlyph({ id, size = 22 }) {
  const path = BRAND_PATHS[id];
  if (!path) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {path}
    </svg>
  );
}

export const ICONS = {
  dashboard: IconDashboard,
  accounts: IconUsers,
  credentials: IconKey,
  composer: IconPen,
  publications: IconList,
  analytics: IconChart,
  users: IconUserCog,
};
